import {
  CLEANUP_ESCALATION_FILTERS,
  INVENTORY_CLEANUP_TASK_TABS,
} from "./inventoryCleanupEmail";

export const TASK_HUB_TABS = {
  ALL: "all",
  BUYER: "buyer",
  MENU_GAP: "menu-gap",
  CLEANUP: "cleanup",
  STALE: "stale",
};

export const TASK_HUB_TAB_OPTIONS = [
  { id: TASK_HUB_TABS.ALL, label: "All" },
  { id: TASK_HUB_TABS.BUYER, label: "Buyer" },
  { id: TASK_HUB_TABS.MENU_GAP, label: "Menu Gap" },
  { id: TASK_HUB_TABS.CLEANUP, label: "Inventory Cleanup" },
  { id: TASK_HUB_TABS.STALE, label: "Stale Inventory" },
];

export const LEGACY_TASK_PATHS = {
  "/buyer-tasks": TASK_HUB_TABS.BUYER,
  "/menu-gap-tasks": TASK_HUB_TABS.MENU_GAP,
  "/inventory-cleanup-tasks": TASK_HUB_TABS.CLEANUP,
  "/stale-inventory-tasks": TASK_HUB_TABS.STALE,
};

export function taskHubPath(tab = TASK_HUB_TABS.ALL, extraParams = {}) {
  const params = new URLSearchParams();
  if (tab && tab !== TASK_HUB_TABS.ALL) {
    params.set("tab", tab);
  }
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  const query = params.toString();
  return query ? `/tasks?${query}` : "/tasks";
}

export function normalizeTaskHubTab(tab) {
  const valid = new Set(Object.values(TASK_HUB_TABS));
  return valid.has(tab) ? tab : TASK_HUB_TABS.ALL;
}

/** Store Execution rollup column → Tasks hub tab (for scorecard deep links). */
export const STORE_EXECUTION_SCORECARD_METRICS = {
  AWAITING_CLEANUP: "awaiting_completion_inventory_cleanup",
  PERSISTING: "persisting_expired_inventory",
  UNRESOLVED: "unresolved_persistence_checks",
  RESOLVED: "resolved_candidates_needing_review",
  MENU_GAP: "open_menu_gap_tasks",
  BUYER_TRANSFER: "open_buyer_transfer",
  STALE: "open_stale_inventory",
  OPEN_COMMAND_CENTER_CARDS: "open_command_center_cards",
};

const SCORECARD_METRIC_TO_TAB = {
  [STORE_EXECUTION_SCORECARD_METRICS.AWAITING_CLEANUP]: TASK_HUB_TABS.CLEANUP,
  [STORE_EXECUTION_SCORECARD_METRICS.PERSISTING]: TASK_HUB_TABS.CLEANUP,
  [STORE_EXECUTION_SCORECARD_METRICS.UNRESOLVED]: TASK_HUB_TABS.CLEANUP,
  [STORE_EXECUTION_SCORECARD_METRICS.RESOLVED]: TASK_HUB_TABS.CLEANUP,
  [STORE_EXECUTION_SCORECARD_METRICS.MENU_GAP]: TASK_HUB_TABS.MENU_GAP,
  [STORE_EXECUTION_SCORECARD_METRICS.BUYER_TRANSFER]: TASK_HUB_TABS.BUYER,
  [STORE_EXECUTION_SCORECARD_METRICS.STALE]: TASK_HUB_TABS.STALE,
};

const SCORECARD_METRIC_TO_CLEANUP_TAB = {
  [STORE_EXECUTION_SCORECARD_METRICS.AWAITING_CLEANUP]: INVENTORY_CLEANUP_TASK_TABS.AWAITING,
  [STORE_EXECUTION_SCORECARD_METRICS.PERSISTING]: INVENTORY_CLEANUP_TASK_TABS.PERSISTING,
  [STORE_EXECUTION_SCORECARD_METRICS.UNRESOLVED]: INVENTORY_CLEANUP_TASK_TABS.AWAITING,
  [STORE_EXECUTION_SCORECARD_METRICS.RESOLVED]: INVENTORY_CLEANUP_TASK_TABS.AWAITING,
};

const SCORECARD_METRIC_TO_CLEANUP_ESCALATION = {
  [STORE_EXECUTION_SCORECARD_METRICS.RESOLVED]: CLEANUP_ESCALATION_FILTERS.RESOLVED_CANDIDATE,
};

export function storeExecutionScorecardPath(metric, storeName) {
  if (metric === STORE_EXECUTION_SCORECARD_METRICS.OPEN_COMMAND_CENTER_CARDS) {
    return "/command-center";
  }
  const tab = SCORECARD_METRIC_TO_TAB[metric];
  if (!tab || !storeName) {
    return null;
  }
  const extraParams = { store: storeName };
  const cleanupTab = SCORECARD_METRIC_TO_CLEANUP_TAB[metric];
  if (cleanupTab && cleanupTab !== INVENTORY_CLEANUP_TASK_TABS.ACTIVE) {
    extraParams.cleanupTab = cleanupTab;
  }
  const cleanupEscalation = SCORECARD_METRIC_TO_CLEANUP_ESCALATION[metric];
  if (cleanupEscalation) {
    extraParams.cleanupEscalation = cleanupEscalation;
  }
  return taskHubPath(tab, extraParams);
}

export function taskMatchesStoreFilter(task, storeFilter) {
  if (!storeFilter) {
    return true;
  }
  const target = storeFilter.trim().toLowerCase();
  if (!target) {
    return true;
  }
  const names = [];
  if (Array.isArray(task?.store_names)) {
    names.push(...task.store_names);
  }
  if (task?.store_name) {
    names.push(task.store_name);
  }
  return names.some((name) => String(name).trim().toLowerCase() === target);
}
